import './App.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { GlobalErrorHandler } from './components/common/GlobalErrorHandler';
import { AuthProvider } from './contexts/AuthContext';
import { LocalAuthProvider } from './contexts/LocalAuthContext';
import LocalLoginPage from './components/auth/LocalLoginPage';
import LocalRegisterPage from './components/auth/LocalRegisterPage';
import LocalProtectedRoute from './components/auth/LocalProtectedRoute';
import ImprovedEnterpriseLayoutPreview from './Layout/main_layout';

function App() {
  return (
    <AuthProvider>
      <LocalAuthProvider>
        <GlobalErrorHandler>
          <ErrorBoundary
            showNotification={true}
            logError={true}
            errorMessage="The application encountered an error. Please try again."
          >
            <Routes>
              <Route path="/login"    element={<LocalLoginPage />} />
              <Route path="/register" element={<LocalRegisterPage />} />

              {/* Main app shell — sidebar, header, tabs, breadcrumbs.
                  Screens are resolved from MODULES_CONFIG → COMPONENT_REGISTRY. */}
              <Route
                path="/home"
                element={
                  <LocalProtectedRoute>
                    <ImprovedEnterpriseLayoutPreview />
                  </LocalProtectedRoute>
                }
              />

              {/* Default: into the layout (gate sends to /login when unauthenticated) */}
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
          </ErrorBoundary>
        </GlobalErrorHandler>
      </LocalAuthProvider>
    </AuthProvider>
  );
}

export default App;
